import { APOE_PLUS_PRODUCT_IDS, APOE_SELECT_PRODUCT_IDS } from '@helpers/apoeProducts';

const myomePdf = (filename: string): string => `https://myome.com/pdfs/${encodeURIComponent(filename)}`;

const PROVIDER_UNDERSTANDING = {
  title: 'Understanding APOE Add-On Results',
  url: myomePdf('m-156-atlas-apoe-provider-understanding-results-guide-v1.pdf'),
};

const SELECT_TECHNICAL = {
  title: 'Technical Overview - Atlas Select',
  url: myomePdf('m-159-atlas-select-apoe-technical-one-pager-v1.pdf'),
};

const PLUS_TECHNICAL = {
  title: 'Technical Overview - Atlas Plus',
  url: myomePdf('m-158-atlas-plus-apoe-technical-one-pager-v1.pdf'),
};

export interface ApoeResultResource {
  title: string;
  url: string;
}

interface ApoeOrderIdentity {
  product_id: string;
  product_name: string;
}

/**
 * Marketing PDFs for a reported APOE add-on. Empty for every other product.
 * Select is PR21059; Plus is PR22057. The product name is the fallback.
 */
export function getApoeResultResources(order: ApoeOrderIdentity): ApoeResultResource[] {
  const isPlusId = APOE_PLUS_PRODUCT_IDS.includes(order.product_id);
  const isSelectId = APOE_SELECT_PRODUCT_IDS.includes(order.product_id);
  const isApoeName = /APOE Add-On/.test(order.product_name);
  const isPlus = isPlusId || (!isSelectId && isApoeName && /^Atlas Plus(?:,|$)/.test(order.product_name));
  const isSelect = isSelectId || (!isPlusId && isApoeName && /^Atlas Select(?:,|$)/.test(order.product_name));

  if (isPlus) return [PROVIDER_UNDERSTANDING, PLUS_TECHNICAL];
  if (isSelect) return [PROVIDER_UNDERSTANDING, SELECT_TECHNICAL];
  return [];
}
